import { ERROR_CODES } from "@/libs/error/types";
import { useMutation } from "@tanstack/react-query";
import { noop } from "lodash";
import axiosWithCredentials from "@/libs/apis/commons";
import { POST_TOKEN_TRANSFER_URL } from "./constants";
import {
  TokenTransferRequestBody,
  TokenTransferRequestUrl,
  TokenTransferResponseBody,
} from "./types";

export type PostTokenTransferMutationProps = TokenTransferRequestUrl & {
  onSuccess?: (data: TokenTransferResponseBody) => Promise<unknown> | void;
  onError?: (e: any) => Promise<unknown> | void;
};

const usePostTokenTransfer = ({
  contractAddress,
  tokenId,
  onSuccess = noop,
  onError = noop,
}: PostTokenTransferMutationProps) => {
  return useMutation(
    async (tokenTransferRequest: TokenTransferRequestBody) =>
      await axiosWithCredentials
        .post(POST_TOKEN_TRANSFER_URL(contractAddress, tokenId), {
          ...tokenTransferRequest,
        })
        .then(({ data }) => data as TokenTransferResponseBody),
    {
      retry: false,
      onSuccess: (data) => onSuccess(data),
      onError: (e) => onError(e),
      useErrorBoundary: false,
    },
  );
};

export default usePostTokenTransfer;
